import { HTTP } from '@/http-common'

function getClient (clientId) {
  return HTTP.get('/clients/' + clientId)
}

function addClient (clientData) {
  let data = JSON.stringify(clientData)

  return HTTP.post('/clients', data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

function bulkAddClients (clientsData) {
  let data = JSON.stringify(clientsData)

  return HTTP.post('/clients/bulk-add', data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

function updateClient (clientData) {
  let data = JSON.stringify(clientData)

  return HTTP.put('/clients/' + clientData.id, data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

function deleteClient (clientId) {
  return HTTP.delete('/clients/' + clientId)
}

function applyRatePlan (clientId) {
  return HTTP.get('/clients/' + clientId + '/apply-rate-plan')
}

function printBill (clientId, months, dateFrom, dateTo, months2, dateFrom2, dateTo2) {
  if (dateFrom2 && dateTo2) {
    return HTTP.get('/clients/' + clientId + '/print-bill?months=' + months + '&date_from=' + dateFrom + '&date_to=' + dateTo + '&months2=' + months2 + '&date_from2=' + dateFrom2 + '&date_to2=' + dateTo2, {responseType: 'arraybuffer'})
  } else {
    return HTTP.get('/clients/' + clientId + '/print-bill?months=' + months + '&date_from=' + dateFrom + '&date_to=' + dateTo, {responseType: 'arraybuffer'})
  }
}

function drawBalance (clientId, newBalance) {
  let data = JSON.stringify({
    balance: newBalance
  })

  return HTTP.post('/clients/' + clientId + '/draw-balance', data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

export { getClient, bulkAddClients, addClient, updateClient, deleteClient, applyRatePlan, printBill, drawBalance }



// WEBPACK FOOTER //
// ./src/services/client.service.js